@for (def of steps(); track def.step) {

  <!-- Spotlight ring around the element to press -->
  @if (targetRect(); as rect) {
    <div class="tutorial-spotlight" aria-hidden="true"
      [style.top.px]="rect.top" [style.left.px]="rect.left"
      [style.width.px]="rect.width" [style.height.px]="rect.height"
      [style.border-radius]="targetRadius()"></div>
  }

  <output #card class="tutorial-card" aria-live="polite" data-testid="tutorial-card"
    [attr.data-step]="def.step"
    [attr.data-placement]="placement()"
    [class.positioned]="cardPosition() !== null"
    [class.yielding]="yielding()"
    [class.floating]="placement() === 'center'"
    [style.top.px]="placement() !== 'center' ? cardPosition()?.top : null"
    [style.left.px]="placement() !== 'center' ? cardPosition()?.left : null">

    @if (placement() !== 'center') {
      <span class="tutorial-arrow" aria-hidden="true"
        [style.left.px]="placement() === 'top' || placement() === 'bottom' ? arrowOffset() : null"
        [style.top.px]="placement() === 'left' || placement() === 'right' ? arrowOffset() : null"></span>
    }

    <div class="tutorial-card-header">
      <span class="tutorial-badge">
        <span class="tutorial-badge-label">{{ languageService.languageJSON.TabbedInfoDialog_Tutorial }}</span>
        <span class="tutorial-badge-count">{{ tutorialService.stepIndex() }}/{{ tutorialService.stepCount }}</span>
      </span>
      <button type="button" class="tutorial-close" (click)="skip()" data-testid="tutorial-close-btn"
        [attr.aria-label]="languageService.languageJSON.TutorialFlow_Skip">
        <img src="assets/icons/light/ui/close.svg" alt="" />
      </button>
    </div>

    @if (def.step === TutorialStep.AddWaypoint && !targetRect()) {
      <!-- "Press and hold" hint: a fingertip dot with rings spreading out of it -->
      <div class="tutorial-hold-hint" aria-hidden="true">
        <span class="tutorial-hold-ring"></span>
        <span class="tutorial-hold-ring delayed"></span>
        <span class="tutorial-hold-dot"></span>
      </div>
    }

    <h4 class="tutorial-title">{{ languageService.languageJSON[usingFallback() && def.fallback ? def.fallback.titleKey : def.titleKey] }}</h4>
    <p class="tutorial-text">{{ languageService.languageJSON[usingFallback() && def.fallback ? def.fallback.textKey : def.textKey] }}</p>

    @if (def.step === TutorialStep.Done) {
      <button type="button" class="ev-button primary tutorial-finish" (click)="finish()" data-testid="tutorial-finish-btn">
        {{ languageService.languageJSON.TutorialFlow_Finish }}
      </button>
    } @else {
      <div class="tutorial-card-footer">
        <div class="tutorial-dots" aria-hidden="true">
          @for (dot of stepDots(); track dot) {
            <span class="tutorial-dot"
              [class.active]="dot === tutorialService.stepIndex()"
              [class.done]="dot < tutorialService.stepIndex()"></span>
          }
        </div>
        <button type="button" class="tutorial-skip" (click)="skip()" data-testid="tutorial-skip-btn">
          {{ languageService.languageJSON.TutorialFlow_Skip }}
        </button>
      </div>
    }
  </output>
}
